// remove the file extension file.txt -> file
export const trimFileExtension = (fileName: string): string => {
  const cleanFilenName = fileName.split('.').slice(0, -1).join('.');

  return cleanFilenName;
};
